<template>
  <div style="clear: both">
    <v-card>
      <v-container fluid>
        <v-row dense>
          <v-col cols="12" sm="12">
            <p  class="v-label v-label--active theme--light">{{ $t('Closed_Stranded_Justification') }}</p>
            <a :href="closedStrandedJustificationMOC" target="_blank" >{{ closedStrandedJustificationMOC }}</a>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="12" sm="7">
            <people-picker
              :label="$t('Closed_Stranded_By')"
              readonly
              :user="closedStrandedUser"
              :inUser="closedStrandedUser"
            ></people-picker>
          </v-col>
          <v-col cols="12" sm="5">
            <v-text-field :value="$filters.DateTimeFilter(closedStrandedDateValue)" readonly dense></v-text-field>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </div>
</template>

<script>
import PeoplePicker from '@/components/peoplePicker/PeoplePicker'
export default {
  data: () => ({}),
  props: {
    closedStrandedReason: {
      type: Object,
      default: null
    },
    mocFormStatus: {
      type: String
    }
  },
  components: {
    PeoplePicker
  },
  methods: {
    closedVoidedUserDisplayName: function (user) {
      return user ? user.displayName : ''
    }
  },
  computed: {
    readonly: function () {
      switch (this.mocFormStatus) {
        default:
          return true
      }
    },
    closedStrandedUser: function () {
      if (this.closedStrandedReason) {
        if (this.closedStrandedReason.closedStrandedBy) {
          return this.closedStrandedReason.closedStrandedBy
        }
      }
      return null
    },
    closedStrandedJustificationMOC: function () {
      if (this.closedStrandedReason) {
        return this.closedStrandedReason.justification
      } else {
        return ''
      }
    },
    closedStrandedDateValue: function () {
      if (this.closedStrandedReason) {
        return this.closedStrandedReason.closedStrandedDate
      } else {
        return null
      }
    }
  }
}
</script>

<style scoped></style>
